import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=280a49e2&scoped=true&"
import script from "./message.js?vue&type=script&lang=js&"
export * from "./message.js?vue&type=script&lang=js&"
import style0 from "./message.scss?vue&type=style&index=0&id=280a49e2&prod&lang=scss&scoped=true&"
import style1 from "./global.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a49e2",
  null
  
)

export default component.exports